import InvoiceHeader from './InvoiceHeader'
import CustomerDetails from './CustomerDetails'
import InvoiceLines from './InvoiceLines'
import InvoiceActions from './InvoiceActions'
import PageSkeleton from 'shared/ui/Skeletons/PageSkeleton'
import NotFound from 'shared/ui/Feedback/NotFound'
import LoadError from 'shared/ui/Feedback/LoadError'
import useInvoice from 'features/invoices/hooks/useInvoice'
import { routes } from 'app/routes'

const MAIN_COL = 'col-9'
const SIDEBAR_COL = 'col-3'

const InvoiceShow = () => {
  const { invoice, isPending, isError } = useInvoice()

  if (isPending) return <PageSkeleton mainCol={MAIN_COL} sidebarCol={SIDEBAR_COL} />
  if (isError) return (
    <LoadError
      title="Failed to load invoice"
      subTitle="An error occurred while loading this invoice. Please try again."
      backTo={routes.invoices.list}
      backLabel="Back to invoices"
    />
  )
  if (!invoice) return (
    <NotFound
      title="Invoice not found"
      subTitle="This invoice doesn't exist or may have been deleted."
      backTo={routes.invoices.list}
      backLabel="Back to invoices"
    />
  )

  return (
    <div className="d-flex flex-column gap-3">
      <InvoiceHeader invoice={invoice} />
      <div className="row g-3">
        <div className={MAIN_COL}>
          <CustomerDetails customer={invoice.customer} />
        </div>
        <div className={SIDEBAR_COL}>
          <InvoiceActions invoice={invoice} />
        </div>
      </div>
      <InvoiceLines invoice={invoice} />
    </div>
  )
}

export default InvoiceShow
